import { useEffect, useState } from 'react';
import ApiProvider from './api/ApiProvider';
import ApiErrorOrRender from './api/ApiErrorOrRender';
import DocumentTitle from './components/DocumentTitle';
import PageSelector from './components/PageSelector';
import CookieLayer from './components/CookieLayer';

import './App.scss';

const cookieAccepted = window.localStorage.getItem('cookieAccepted');

const App = () => {
    const [showCookie, setShowCookie] = useState(!cookieAccepted);

    useEffect(() => {
        if (!showCookie) {
            // Remove no-scroll class from body, set by the modal component sbk-modal
            document.body.classList.remove('no-scroll');
        }
    }, [showCookie]);

    return (
        <ApiProvider>
            <ApiErrorOrRender>
                <DocumentTitle title="Lade..." />
                <PageSelector />

                {showCookie && <CookieLayer setShowCookie={setShowCookie} />}
            </ApiErrorOrRender>
        </ApiProvider>
    );
};

export default App;
